import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customUrlField"]

  toggle(event) {
    const selectedValue = event.target.value
    
    if (selectedValue === 'custom') {
      this.customUrlFieldTarget.style.display = 'block'
    } else {
      this.customUrlFieldTarget.style.display = 'none'
    }
  }
}